import React from "react";
import { Panel, Overline } from "./Panel";

export function StatCard({ icon: Icon, label, value, unit, accent = "var(--accent)", sub, testid }) {
  return (
    <Panel hover className="p-6 fade-up" data-testid={testid}>
      <div className="flex items-start justify-between">
        <Overline>{label}</Overline>
        <div
          className="w-9 h-9 rounded-md flex items-center justify-center shrink-0"
          style={{ background: "var(--accent-soft)", color: accent }}
        >
          <Icon size={18} strokeWidth={2.2} />
        </div>
      </div>
      <div className="mt-5 flex items-baseline gap-1.5">
        <span className="font-mono font-medium text-4xl tracking-tight tabular-nums" style={{ color: accent }} data-testid={`${testid}-value`}>
          {value}
        </span>
        {unit && <span className="font-mono text-sm text-[var(--t2)]">{unit}</span>}
      </div>
      {sub && <div className="mt-1 text-xs text-[var(--t2)] font-mono">{sub}</div>}
    </Panel>
  );
}
